export const GPS_DISABLED_MESSAGE =
  "Live GPS tracking is currently disabled. Existing FleetX operations remain available.";
export const GPS_UNAVAILABLE_MESSAGE =
  "Live tracking could not be loaded. Existing FleetX operations are unaffected.";
export const NOT_AVAILABLE = "Not available";
